import React from 'react'
import { ArrayInput, SimpleFormIterator } from 'react-admin'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'
import KAccordion from 'ui-shared/accordions/KAccordion'
import StandardPricingInput from 'ui-shared/FormComponents/pricing/standard/StandardPricingInput'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import { useFormContext } from 'react-hook-form'
import { Drink } from 'services/api/entities/catalog/drink/types/internal/drink-models'

const VariantsFormPartial: React.FC = (props) => {
  const { setValue, getValues, watch } = useFormContext<Drink>()
  const variants = getValues('variants')

  const hasMultipleVariants = watch('hasMultipleVariants')
  const name = watch('name')

  if (!hasMultipleVariants) {
    if (variants?.length !== 1) {
      setValue('variants.0.name', name)
      setValue('variants.0.pricing', STANDARD_PRICING_STARTUP)
    }
    setValue('variants.0.name', name)
  }

  return (
    <KAccordion accordionTitle="Variants">
      <ArrayInput
        {...props}
        source="variants"
        defaultValue={getDefaultVariants()}
      >
        <SimpleFormIterator
          disableAdd={!hasMultipleVariants}
          disableRemove={!hasMultipleVariants}
        >
          <LocalizedInputText
            source="name"
            forceDisabled={!hasMultipleVariants}
          />
          <StandardPricingInput
            source="pricing"
            hideFixedPrice
            label="form.fields.pricing"
          />
        </SimpleFormIterator>
      </ArrayInput>
    </KAccordion>
  )
}

export default VariantsFormPartial

const getDefaultVariants = (name = '') => [
  {
    name,
    pricing: STANDARD_PRICING_STARTUP,
  },
]
